.container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-shrink: 0;
    border-bottom: 1px solid var(--off-white-dk);
}
